import { BANK_PAYMENT_SLIP_ENTRY_REQUEST, CREATE_BANK_PAYMENT_SLIP_ENTRY, GET_BANK_PAYMENT_SLIP_ENTRIES, UPDATE_BANK_PAYMENT_SLIP_ENTRY, DELETE_BANK_PAYMENT_SLIP_ENTRY, BANK_PAYMENT_SLIP_ENTRY_REQUEST_FAILURE, GET_AVAILABLE_BANK_PAYMENT_TRANSACTION, GET_BANK_PAYMENT_SLIP_ENTRY_PAGE, BANK_PAYMENT_SLIP_ENTRY_REQUEST_SUCCESS } from '../types';

const initialState = {
  bankPaymentSlipEntries: [],
  bankPaymentSlipEntriesPage: [],
  availablePaymentTransactions: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const bankPaymentSlipEntryReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_PAYMENT_SLIP_ENTRY_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_PAYMENT_SLIP_ENTRIES: {
      return {
        ...state,
        bankPaymentSlipEntries: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_BANK_PAYMENT_SLIP_ENTRY_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        bankPaymentSlipEntriesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case GET_AVAILABLE_BANK_PAYMENT_TRANSACTION: {
      return {
        ...state,
        availablePaymentTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_BANK_PAYMENT_SLIP_ENTRY:
      return {
        ...state,
        bankPaymentSlipEntries: [action.payload, ...state.bankPaymentSlipEntries],
        loading: false,
        error: null
      };
    case UPDATE_BANK_PAYMENT_SLIP_ENTRY:
      const bankPaymentSlipEntriesData = state.bankPaymentSlipEntries.slice(0);
      const uIndex = bankPaymentSlipEntriesData.findIndex((data) => data.id === action.payload.id);
      bankPaymentSlipEntriesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bankPaymentSlipEntries: [ ...bankPaymentSlipEntriesData ],
        loading: false,
        error: null
      };
    case DELETE_BANK_PAYMENT_SLIP_ENTRY:
      const bankPaymentSlipEntries = state.bankPaymentSlipEntries?.slice(0);
      const index = bankPaymentSlipEntries.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bankPaymentSlipEntries.splice(index, 1);
      }
      return {
        ...state,
        bankPaymentSlipEntries: [...bankPaymentSlipEntries],
        loading: false,
        error: null
      }
    case BANK_PAYMENT_SLIP_ENTRY_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
    case BANK_PAYMENT_SLIP_ENTRY_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankPaymentSlipEntryReducer;